import { ArcElement, Chart as ChartJS, Legend, Tooltip } from 'chart.js'
import { Doughnut } from 'react-chartjs-2'

import {
	Card,
	CardContent,
	CardHeader,
	CardTitle,
} from '@/modules/shared/components/ui/card'

import { useChartSalesByProductReport } from './useChartSalesByProductReport'

ChartJS.register(ArcElement, Tooltip, Legend)

export function ChartSalesByProductReport() {
	const { chartData } = useChartSalesByProductReport()

	return (
		<Card>
			<CardContent className="max-w-[320px] m-auto">
				<CardHeader>
					<CardTitle className="text-lg">Gráfico Família x Valor</CardTitle>
				</CardHeader>
				<Doughnut
					data={chartData}
					options={{
						plugins: {
							datalabels: {
								display: false,
							},
						},
					}}
				/>
			</CardContent>
		</Card>
	)
}
